import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Bill } from '../models/bill.model';
import { JsonResult } from '../core/json-result.model';
import { Observable } from 'rxjs';
import { Email } from '../core/models/email.model';
import { DetailedBill } from '../models/bill/detailed-bill.model';
import { EnvironmentService } from '../core/services/environment.service';
import { CommonService } from './common.service';
import { takeUntil } from 'rxjs/operators';
import { PendingBill } from '../models/pendingBill.model';

@Injectable({
  providedIn: 'root'
})
export class BillService {
  private controller: string = "Bill";
  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService,
    private commonService: CommonService) { }

  listRecent(clientCode: string): Observable<JsonResult<Bill[]>> {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/ListLastBills`;
    let params = new HttpParams();
    params = params.append("clientCode", clientCode)
    return this.httpClient.get<JsonResult<Bill[]>>(url, { params: params }).pipe(takeUntil(this.commonService.unauthorizedAnnounced));
  }

  /**
   * Obtiene un recibo detallado
   * @param clientCode código de cliente
   * @param month mes
   * @param year año
   */
  getDetailedBill(clientCode: string, month: number, year: number) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/GetDetailedBill`;
    let params = new HttpParams();
    params = params.append("clientCode", clientCode)
    params = params.append("month", month.toString())
    params = params.append("year", year.toString())
    return this.httpClient.get<JsonResult<DetailedBill>>(url, { params: params });
  }

  sendEmail(email: Email): Observable<JsonResult<any>> {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/sendEmail`;
    return this.httpClient.post<JsonResult<any>>(url, email);
  }
  download(issueDate: Date, clientCode: string) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/download`;
    let headers = new HttpHeaders();
    headers = headers.append("Accept", "application/pdf");
    let params = new HttpParams();
    params = params.append("issueDate", issueDate.toString())
    params = params.append("clientCode", clientCode)
    return this.httpClient.get(url, { headers: headers, params: params, responseType: 'blob' });
  }

  listForComplaintBook(clientCode: string) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/ListForComplaintBook`;
    let httpParams = new HttpParams();
    httpParams = httpParams.append('clientCode', clientCode)

    return this.httpClient.get<JsonResult<Bill[]>>(url, { params: httpParams }).pipe(takeUntil(this.commonService.unauthorizedAnnounced));
  }

  listForComplaintBookExternal(clientCode: string, token: string = '') {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/ListForComplaintBook-external`;
    let httpParams = new HttpParams();
    httpParams = httpParams.append('clientCode', clientCode)

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'X-SKIP-REPLACE-TOKEN': 'X-SKIP-REPLACE-TOKEN'
    })
    return this.httpClient.get<JsonResult<Bill[]>>(url, { params: httpParams, headers: token ? headers : {} }).pipe(takeUntil(this.commonService.unauthorizedAnnounced));
  }
  ListPendingBill(clientCode: string) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/ListPendingBill`;
    let httpParams = new HttpParams();
    httpParams = httpParams.append('clientCode', clientCode)
    return this.httpClient.get<JsonResult<PendingBill[]>>(url, { params: httpParams }).pipe(takeUntil(this.commonService.unauthorizedAnnounced));
  }

  GetAlternativeCode(clientCode: string) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/GetAlternativeCode`;
    let httpParams = new HttpParams();
    httpParams = httpParams.append('clientCode', clientCode)
    return this.httpClient.get<any>(url, { params: httpParams }).pipe(takeUntil(this.commonService.unauthorizedAnnounced));
  }
}